import React from 'react';
import { useSelector } from 'react-redux';
import classes from './CompetitionLogo.module.css';
import starsChallengeImageHe from '../../../../assets/InfoSections/starsChallenge.png';
import starsChallengeImageAr from '../../../../assets/InfoSections/starsChallengeAr.png';

const CompetitionLogo = ({ width, height, withBackground = false, className = '', src }) => {
  
  const { lang } = useSelector(state => state.translate);
  const widthStyle = width ? { width } : {};
  const heightStyle = height ? { height } : {};
  
  // Use src from props if provided (for contest-specific logos), otherwise use default assets
  let imageSource;
  if (src) {
    if (typeof src === 'object' && src[lang]) {
      imageSource = src[lang];
    } else if (typeof src === 'string') {
      imageSource = src;
    } else {
      imageSource = lang === 'he' ? starsChallengeImageHe : starsChallengeImageAr;
    }
  } else {
    imageSource = lang === 'he' ? starsChallengeImageHe : starsChallengeImageAr;
  }
 
  return (
    <div
      className={`${classes.Container} ${className} ${withBackground ? classes.WithBackground : ''}`}
      style={{ 
        ...widthStyle, 
        ...heightStyle,
        backgroundImage: `url(${imageSource})`
      }}
      aria-label="אתגר הכוכבים"
    />
  );
};

export default CompetitionLogo;
